export default __webpack_public_path__ + "static/media/hadluwaterfall.af0f8007.jpg";